import React from "react";
import "./NoSlug.css";
import Header from "../Header/Header";
import NoIndexMeta from "../../utils/NoIndexMeta";

const NoSlug = () => {
  return (
    <div>
      <NoIndexMeta />
      <Header />
      <p className="zoom-area">
        {/* <b>CSS</b> animations to make a cool 404 page.{" "} */}
      </p>
      <section className="error-container">
        <span className="four">
          <span className="screen-reader-text">4</span>
        </span>
        <span className="zero">
          <span className="screen-reader-text">0</span>
        </span>
        <span className="four">
          <span className="screen-reader-text">4</span>
        </span>
      </section>
      <section className="error-container-mobile">
        <div classNameName="error-text">404</div>
      </section>
      <div className="link-container">
        <a href="/" className="more-link">
          Visit the Home
        </a>
      </div>
    </div>
  );
};

export default NoSlug;
